import React, {Component} from 'react';

export default class Service extends Component{
    render(){

        return (
            <div>{this.props.children}</div>
        )
    }
}
